import React from 'react';

export default React.memo(function GameCardSkeleton({className}) {

  return (
    <div
      className={`relative flex w-full h-full rounded-3xl overflow-hidden select-none opacity-70 ${className}`}>
      <div className={'flex items-center justify-center w-full h-full'}>
        <div className={'w-full h-full skeleton'}/>
      </div>
    </div>
  );
})
